import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";
import { Page } from "#/components/page";
import { SettingsPage } from "#/components/settings-page";
import { useUser } from "#/modules/util.auth/use-user";
import { m } from "#/paraglide/messages";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/account-settings",
)({
  component: AccountSettingsLayout,
});

// Portal's `AccountSettingsLayout` (from user.account-settings/components) inlined into the route.
function AccountSettingsLayout() {
  const user = useUser();
  const { school } = useParams({ strict: false });

  if (!user || !school) {
    return null;
  }

  return (
    <SettingsPage>
      <SettingsPage.Header>
        <Page.Title>
          {user.firstName} {user.lastName}
        </Page.Title>
        <p className="text-muted-foreground text-sm">{user.email}</p>
      </SettingsPage.Header>

      <SettingsPage.Body>
        <SettingsPage.Nav>
          <SettingsPage.NavLink
            from={Route.fullPath}
            to="/$locale/{-$schoolyear}/$school/account-settings/account-info"
            params={(prev: Record<string, string>) => prev}
          >
            {m["account.account_info"]()}
          </SettingsPage.NavLink>
          <SettingsPage.NavLink
            from={Route.fullPath}
            to="/$locale/{-$schoolyear}/$school/account-settings/security"
            params={(prev: Record<string, string>) => prev}
          >
            {m["account.security"]()}
          </SettingsPage.NavLink>
        </SettingsPage.Nav>

        <SettingsPage.Content>
          <Outlet />
        </SettingsPage.Content>
      </SettingsPage.Body>
    </SettingsPage>
  );
}
